import { AppStoreButton, PlayStoreButton } from 'components/DownloadButtons';
import { DownloadURL } from "constants/download";
import * as React from 'react';
export default {
  AppStoreButton,
  PlayStoreButton,
  DownloadURL,
  React
};